import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.timers.js";
export var WINDOW_TMS_PROPERTY = 'tms';
export var WINDOW_DATALAYER_PROPERTY = 'tc_vars';
export var TmsEvent = {
  EVENT: 'TMSEvent',
  DATA_LAYER_READY: 'TMSDataLayerReady',
  DATA_LAYER_CHANGE: 'TMSDataLayerChange',
  VIRTUAL_PAGE_READY: 'TMSVirtualPageReady'
};
var dispatchTmsEvent = function dispatchTmsEvent(target, eventType, value) {
  var tmsEvent = new CustomEvent(TmsEvent.EVENT, {
    detail: {
      eventType: eventType,
      value: value
    }
  });
  target.dispatchEvent(tmsEvent);
};
export var hitEventTms = function hitEventTms(target, eventType) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (typeof data === 'string') {
    data = JSON.parse(data);
  }
  if (window[WINDOW_DATALAYER_PROPERTY] && window[WINDOW_DATALAYER_PROPERTY].cdl_datalayer_ready === true) {
    dispatchTmsEvent(target, eventType, data);
  } else {
    window.addEventListener(TmsEvent.DATA_LAYER_READY, function () {
      // Timeout at 0 to delay this listener after others that uses TMS "ready" signal
      setTimeout(function () {
        dispatchTmsEvent(target, eventType, data);
      }, 0);
    }, {
      once: true
    });
  }
};
export var appendToTcVarsGlobal = function appendToTcVarsGlobal(component) {
  if (component.target.dataset.tcvars) {
    component.componentTcVarsReady({
      tcvars: JSON.parse(component.target.dataset.tcvars.replace(/'/g, '"'))
    });
  }
};
export var appendToTcVarsComponent = function appendToTcVarsComponent(objectToAppend) {
  if (_typeof(objectToAppend) !== 'object') {
    return;
  }
  var updatedTcVars = [];
  if (this.target.dataset.tcvars) {
    var fixedTcVars = this.target.dataset.tcvars.replace(/'/g, '"');
    updatedTcVars = JSON.parse("[".concat(fixedTcVars, "]"));
  }
  updatedTcVars.push(objectToAppend);
  this.target.dataset.tcvars = JSON.stringify(updatedTcVars);
};
export var getTmsInstance = function getTmsInstance() {
  var _window$WINDOW_TMS_PR;
  return (_window$WINDOW_TMS_PR = window[WINDOW_TMS_PROPERTY]) !== null && _window$WINDOW_TMS_PR !== void 0 ? _window$WINDOW_TMS_PR : new Proxy({}, {
    get: function get() {
      return function () {
        return function () {
          return undefined;
        };
      };
    }
  }); // Placeholder if TMS is missing;
};